<template>
  <Container>
    <div class="flex-wrap flex-between" style="padding:0 10px">
    <Toolbar
      :items="basicTools"
      v-model="filter"
      :counts="counts"
      :height="40"
      @on-event="handleEvent"
    >
    <div class="flex-wrap" style="height:30px;padding:0 10px;background:var(--bg3);margin-left:0px;border:1px solid var(--border);border-radius:3px;">
      高级筛选 <i-switch v-model="showDetailFilter" @on-change="calcTableHeight" style="margin-left:10px;" size="small"></i-switch></div>
    </Toolbar>
    <div class="flex-wrap">
      <Button type="primary" icon="md-add" @click="importExcel" style="margin-right:10px">从Excel导入</Button>
      <Button style="margin-right:5px" icon="md-add" type="primary" @click="showCreateForm">新增员工</Button>
      <Button style="margin-left:5px" icon="md-download" @click="exportExcel" />
    </div>
    </div>
    <div style="height:140px;margin:0 15px;background:#00000011;padding:5px;border-radius:3px;border:1px solid var(--border)" v-if="showDetailFilter">
      <Toolbar
      :items="detailTools"
      v-model="filter"
      :counts="counts"
      :height="65"
      @on-event="handleEvent"
    >
    </Toolbar>
    <Toolbar
      :items="workTools"
      v-model="filter"
      :counts="counts"
      :height="65"
      @on-event="handleEvent"
    >
    </Toolbar>
    </div>

    <div :style="`height:calc(100% - ${filterHeight}px);background:linear-gradient(to bottom right,var(--bg2),var(--bg3));padding:0 15px;width:calc(100%);margin-top:10px;`">
      <BaseTable
        ref="table"
        :columns="columns"
        :data="items"
        :page="page"
        border
        :remote-get-all="getAllForExport"
        :page-size="pagesize"
        @event="handleEvent"
        :loading="loading"
        :count="total"
      ></BaseTable>
    </div>

    <Drawer v-model="showEmployeeEditor" :width="900">

      <BaseLoading v-if="loadingEditor"></BaseLoading>
      <FormCreateEmployee
        v-else
        :value="current"
        @on-create="handleCreateEmployee"
        @on-update="handleUpdateEmployee"
        @on-cancel="showEmployeeEditor=false"
      />
    </Drawer>

    <Modal v-model="showDismissEditor" title="离职办理（简易)" :width="600" footer-hide>
      <FormDismissEmployee
        :value="formData"
        :uid="current.id"
        @on-submit="handleDismissEmployee"
        @on-cancel="showDismissEditor=false"
      ></FormDismissEmployee>
    </Modal>

    <BaseImportExcel
      v-model="showImporter"
      ref="importer"
      :columns="importColumns"
      @on-submit="handleImportData"
    />


  </Container>
</template>

<script>
import Container from '@/components/app/container';
import Toolbar from '@/components/app/toolbar';
import FormCreateEmployee from '@components/forms/CreateEmployee';
import FormDismissEmployee from '@components/forms/DismissEmployee';
import {mapGetters} from 'vuex';
import {cloneDeep} from 'lodash';
import PageStateMixin from '@/mixins/page_state';
import moment from 'moment';
export default {
  components: {Container, Toolbar, FormCreateEmployee, FormDismissEmployee},
  routerOption: {
    as_default: true,
  },
  mixins: [PageStateMixin],
  mounted() {
    this.getData();
    this.$api.afterLogin(()=>{
      this.getStatusCounts();
      this.$store.dispatch('session/getDeps');
    });

    this.$nextTick(()=>{
      if (this.$refs && this.$refs.table && this.$refs.table.calcTableHeight) {
        this.$refs.table.calcTableHeight();
      }
    });
  },
  data() {
    return {
      showDismissEditor: false,
      loading: false,
      loadingEditor: false,
      showDetailFilter: false,
      showEmployeeEditor: false,
      showEmployeeDetail: false,
      filter: {},
      formData: {},
      current: {},

      page: 1,
      pagesize: 20,
      total: 10,
      items: [],
      counts: {
        '全职': 0,
        '退休返聘': 0,
        '实习': 0,
      },
      order: {
        key: 'employee_date',
        order: 'desc',
      },
      showImporter: false,
      importErrors: [],

      pageStateFields: ['filter', 'page', 'pagesize', 'showDetailFilter'],
    };
  },
  computed: {
    ...mapGetters('session', ['deps']),

    filterHeight() {
      return this.showDetailFilter?200:60;
    },
    basicTools() {
      return [{
        key: 'search',
        placeholder: '输入项目名称/招标单位/搜索',
        type: 'search',
        width: 300,
      }, {
        key: 'employeeType',
        type: 'tabs',
        subs: [{
          key: '全职',
          icon: 'file',
          countable: true,
          name: '全职',
        }, {
          key: '退休返聘',
          icon: 'pm2',
          countable: true,
          name: '退休返聘',
        }, {
          key: '实习',
          icon: 'xiangmu2',
          countable: true,
          name: '实习',
        }],
      }, {
        key: 'refresh',
        icon: 'md-refresh',
        type: 'icon-button',
      }, {
        type: 'clear-button',
      }];
    },
    detailTools() {
      return [{
        name: '性别',
        key: 'gender',
        type: 'tabs',
        subs: ['男', '女'],
      }, {
        name: '政治面貌',
        key: 'political_status',
        type: 'tabs',
        subs: ['党员', '群众'],
      }, {
        name: '婚姻状况',
        key: 'marital_status',
        type: 'tabs',
        subs: ['已婚', '未婚'],
      }, {
        key: 'education',
        type: 'tabs',
        name: '学历',
        multiple: true,
        subs: ['中专', '大专', '本科', '研究生'],
      }, {
        key: 'age-range',
        type: 'tabs',
        name: '年龄',
        multiple: true,
        subs: [{
          name: '20岁以下',
          key: [moment().startOf('year').subtract(19, 'year').format('YYYY-MM-DD'), null],
        }, {
          name: '20岁-29岁',
          key: [
            moment().startOf('year').subtract(29, 'year').format('YYYY/MM/DD'),
            moment().startOf('year').subtract(20, 'year').format('YYYY/MM/DD'),
          ],
        }, {
          name: '30岁-39岁',
          key: [
            moment().startOf('year').subtract(39, 'year').format('YYYY/MM/DD'),
            moment().startOf('year').subtract(30, 'year').format('YYYY/MM/DD'),
          ],
        }, {
          name: '40岁-49岁',
          key: [
            moment().startOf('year').subtract(49, 'year').format('YYYY/MM/DD'),
            moment().startOf('year').subtract(40, 'year').format('YYYY/MM/DD'),
          ],
        }, {
          name: '50岁以上',
          key: [
            null,
            moment().startOf('year').subtract(50, 'year').format('YYYY/MM/DD'),
          ],
        }],
      }];
    },
    workTools() {
      return [{
        key: 'deps',
        type: 'tabs',
        name: '事业部',
        multiple: true,
        subs: this.deps.filter((v)=>v.top).map((v)=>({...v, key: v.id})),
      }, {
        key: 'profile_rank',
        type: 'tabs',
        name: '职称',
        multiple: true,
        subs: ['初级', '中级', '高级', '无'],
      }];
    },
    columns() {
      return [{
        key: 'id',
        type: 'index',
        title: '序',
        width: 50,
      }, {
        key: 'profile_code2',
        title: '档案号',
        width: 80,
        sortable: 'custom',
      }, {
        key: 'top_dep_name',
        title: '事业部',
        width: 120,

        sortable: false,
        type: 'text',
        render: (h, {row})=>{
          if (row.top_dep) {
            return h('span', row.top_dep.name);
          } else {
            return h('span', '无');
          }
        },
      }, {
        key: 'main_dep_name',
        title: '部门',
        width: 120,
        type: 'text',
        sortable: false,
        render: (h, {row})=>{
          if (row.main_dep) {
            return h('span', row.main_dep.name);
          } else {
            return h('span', '无');
          }
        },
      }, {key: 'name', width: 90, title: '姓名', sortable: 'custom',
        render: (h, {row})=>{
          const tag = h('img', {attrs: {
            src: 'https://nbgz-pmis-1257839135.cos.ap-shanghai.myqcloud.com/beauty/new.gif',
          }, style: 'width:30px;height:13px;margin-left:10px;'});
          const icon = h('BaseIcon', {style: 'padding:3px;background:var(--primary);margin-left:10px;margin-right:5px;', props: {
            icon: 'user', size: 14, color: 'var(--hover-text)',
          }});

          const name = h('div', {style: 'white-space:nowrap;text-overflow:ellipsis;width:calc(100% - 30px;);overflow:hidden;'}, row.realname);
          return h('div', {
            class: 'flex-wrap',
            style: {
              color: 'var(--primary)',
              fontWeight: 'bold',
              textAlign: 'left',
              cursor: 'pointer',
            },
            on: {
              click: ()=>{
                this.Edit(row);
              },
            },
          }, [icon, name]);
        },
      }, {
        key: 'gender',
        title: '姓别',
        sortable: 'custom',
        width: 80,
      }, {
        key: 'birthday',
        title: '出生年月',
        sortable: 'custom',
        width: 100,
      }, {
        key: 'age',
        title: '年龄',
        sortable: false,
        width: 100,
      }, {
        key: 'position',
        title: '职位',
        width: 100,
        type: 'text',
      }, {
        key: 'employeeType',
        title: '聘用类型',
        sortable: 'custom',
        align: 'center',
        width: 120,
      }, {
        key: 'employee_date',
        title: '入职时间',
        sortable: 'custom',
        type: 'time',
        width: 100,
        option: {
          type: 'date',
        },
      }, {
        key: 'phone',
        title: '电话',
        sortable: false,
        align: 'center',
        width: 120,
        type: 'phone',
      }, {
        key: 'account_id',
        title: '账号',
        sortable: false,
        width: 100,
        render: (h, {row})=>{
          return h('span', row.account_id?'已启用':'-');
        },
      }, {key: 'tools', width: 140, title: '操作', sortable: false,
        render: (h, {row})=>{
          const that =this;
          const buttons = [
            h('Button', {props: {size: 'small', icon: 'md-create'}, on: {click: ()=>{
              that.Edit(row);
            }}}),
            h('Button', {props: {size: 'small', icon: 'md-build'}, on: {click: ()=>{
              that.Dismiss(row);
            }}}),
            h('Button', {props: {size: 'small', icon: 'md-trash'}, on: {click: ()=>{
              that.handleDelete(row);
            }}}),
          ];
          return h('div', {class: 'flex split5'}, [buttons]);
        },
      }];
    },
    importColumns() {
      return [
        {key: 'index', title: '序号', width: 60},
        {
          key: 'raw_dep',
          title: '部门',
          width: 100,
        }, {
          key: 'raw_dep_id',
          title: '部门编号',
          width: 100,
        },
        {
          key: 'profile_code',
          title: '档案号',
          width: 100,
        }, {
          key: 'profile_code2',
          title: '档案号2',
          width: 100,
        }, {
          key: 'realname',
          title: '姓名',
          width: 100,
        }, {
          key: 'position',
          title: '岗位',
          width: 100,
        }, {
          key: 'id_card_no',
          title: '身份证号',
          width: 100,
        }, {
          key: 'gender',
          title: '性别',
          width: 100,
        }, {
          key: 'birthday',
          title: '出生年月',
          width: 120,
        }, {
          key: 'age',
          title: '年龄',
          width: 100,
        }, {
          key: 'native_place',
          width: 160,
          title: '籍贯',
        }, {
          key: 'jobtitle',
          width: 120,
          title: '职称',
        }, {
          key: 'jobtitle_code',
          width: 140,
          title: '职称证书号',
        }, {
          key: 'jobtitle_subject',
          width: 140,
          title: '职称专业',
        }, {
          key: 'joibtitle_accquired_at',
          width: 120,
          title: '职称考评时间',
        }, {
          key: 'education',
          width: 120,
          title: '学历',
        }, {
          key: 'graduate_institution',
          width: 160,
          title: '毕业院校',
        }, {
          ignore: true,
        }, {
          key: 'major',
          width: 120,
          title: '专业',
        }, {
          key: 'graduated_at',
          width: 120,
          title: '毕业时间',
        }, {
          key: 'graduated_at2',
          width: 120,
          title: '第二学历毕业时间',
        }, {
          ignore: true,
        }, {
          ignore: true,
        }, {
          key: 'employee_date',
          title: '入职时间',
          width: 120,
        }, {
          ignore: true,
        }, {
          ignore: true,
        }, {
          key: 'now_contract_finished_at',
          title: '当前合同截止',
          width: 120,
        }, {
          ignore: true,
        }, {
          ignore: true,
        }, {
          key: 'phone',
          title: '联系电话',
          width: 140,
        }, {
          key: 'address',
          title: '住址',
          width: 160,
        }, {
          key: 'contact_info',
          title: '家属信息',
          width: 140,
        }];
    },
  },
  methods: {
    Dismiss(row) {
      this.showDismissEditor = true;
      this.current = row;
      this.formData = {
        name: row.realname,
        employee_id: row.id,
        lastWorkDay: moment().format('YYYY/MM/DD'),
        main_dep_id: row.main_dep?row.main_dep.id:null,
        top_dep_id: row.top_dep?row.top_dep.id:null,
        name: row.realname,
      };
    },
    importExcel() {
      this.$refs.importer.importExcel();
      this.showImporter = true;
      this.importErrors = [];
    },
    handleDismissEmployee() {

    },
    handleImportData(items) {
      const formattedItems = [];
      items.forEach((e)=>{
        const item = e;
        delete item.phone;
        if (item.now_contract_finished_at == '退休返聘') {
          item.employeeType = '退休返聘';
        }

        formattedItems.push(item);
      });
      this.Confirm(`将更新在职员工的信息，是否继续?</div>`, ()=>{
        this.$api.post('oa/o-employees/import', formattedItems).then((res)=>{
          this.Success('导入成功');
          this.showConfigImporter = false;
          this.page =1;
          this.getData();
        });
      });
    },
    OpenUserDetail(item) {
      this.loadingEditor = true;
      this.showEmployeeDetail = true;
      this.$api.get(`oa/o-employees/${item.id}?edit=1`).then((res)=>{
        this.current = res.data.data;
        this.loadingEditor = false;
      }).catch((e)=>{
        this.Error('读取失败:'+e);
        this.loadingEditor = false;
        this.showEmployeeDetail = true;
      });
    },
    calcTableHeight() {
      this.$nextTick(()=>{
        if (this.$refs && this.$refs.table && this.$refs.table.calcTableHeight) {
          this.$refs.table.calcTableHeight();
        }
      });
    },
    Edit(item) {
      this.loadingEditor = true;
      this.showEmployeeEditor = true;
      this.$api.get(`oa/o-employees/${item.id}?edit=1`).then((res)=>{
        this.current = res.data.data;
        this.loadingEditor = false;
        this.formData = cloneDeep(this.current);
        this.showEditor = true;
      }).catch((e)=>{
        this.Error('读取失败:'+e);
        this.loadingEditor = false;
        this.showEmployeeEditor = true;
      });
    },
    getAllForExport(cb) {
      this.$api.getAll('/oa/o-employees', {
        order: this.order,
        filter: {...this.filter, employee_state: '正式'},
        related: ['deps'],
      }).then((res)=>{
        const items = res.data.data;
        if (cb) {
          cb(items);
        }
      });
    },
    exportExcel() {
      this.$refs.table.exportExcel();
    },
    handleCreateEmployee(model) {
      this.loading = true;
      this.$api.post('oa/o-employees', model).then((res)=>{
        this.Success('添加成功');
        this.getData();
        this.formData = {
          dep: {},
        };
        this.current = {};
        this.showEmployeeEditor = false;
      }).catch((e)=>{
        this.Error('添加失败:'+e);
      });
    },
    handleUpdateEmployee(model) {
      this.loading = true;
      this.$api.patch(`oa/o-employees/${this.current.id}`, model).then((res)=>{
        this.Success('修改成功');
        this.formData = {};
        this.current = {};
        this.getData();
        this.showEmployeeEditor = false;
      }).catch((e)=>{
        this.Error('添加失败:'+e);
      });
    },
    getStatusCounts() {
      this.$api.getCounts('/oa/o-employees', {
        count_by: 'employeeType',
        filter: {employee_state: '正式'},
      }).then((res)=>{
        this.counts = Object.assign(this.counts, res.data.data);
      });
    },
    getData() {
      this.loading = false;
      this.$api.afterLogin(()=>{
        this.$api.getPaged('/oa/o-employees', {
          page: this.page,
          pagesize: this.pagesize,
          order: this.order,
          filter: {...this.filter, employee_state: '正式'},
          related: ['deps'],
        }).then((res)=>{
          const {count, list} = res.data.data;
          list.forEach((v)=>{
            console.log(v);
            if (v.birthday) {
              v.age = moment.duration(moment()-moment(v.birthday, 'YYYY/MM/DD')).as('years');
              v.age = parseInt(v.age);
            }
            if (v.deps) {
              v.top_dep = v.deps.find((d)=>d.ref && d.ref.top).ref;
              if (v.top_dep) {
                v.top_dep_name = v.top_dep.name;
              }
              v.main_dep = v.deps.find((d)=>d.ref && d.ref.parent_id && v.deps.find((t)=>t.ref && t.ref.parent_id == d.id) == null);
              console.log(v.main_dep);

              if (v.main_dep && v.main_dep.ref) {
                v.main_dep = v.main_dep.ref;
                v.main_dep_name = v.main_dep;
              }
            }
          });
          this.items = list;
          this.total = count;
          this.loading = false;
        });
      });
    },
    showCreateForm() {
      this.current = {};
      this.showEmployeeEditor = true;
    },
    handleEvent({type, key, value, data}) {
      const eventMap = {
        'add': this.showCreateForm,
        'search': this.getData,
        //    create:this.createItem,
        'refresh': ()=>{
          this.getStatusCounts();
          this.getData();
        },
        'detail-filter': ()=>{
          this.showDetailFilter = value;
        },
        //    update:this.updateItem,
        'tab-change': ()=>{
          this.page = 1;
          this.getData();
        },
        'page-change': ()=>{
          this.page = data;
          this.getData();
        },
        'page-size-change': ()=>{
          this.page = 1;
          this.pagesize = data;
          this.getData();
        },
        'sort': ()=>{
          if (!data || !data.key) {
            this.order = {
              key: 'employee_date',
              order: 'desc',
            };
          } else {
            this.order = data;
          }
          this.page = 1;
          this.getData();
        },
      };


      const eventHandler = eventMap[type];
      if (eventHandler) {
        eventHandler(value);
      }
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
